module.exports = geoip2;